export function setData (state, payload) {
  state.prefix = payload.prefix
  state.title = payload.title
  state.text = payload.text
  state.create = payload.create
  state.createText = payload.createText
  state.breadcrumb = payload.breadcrumb
  state.searchField = payload.searchField
}
